import { Navigate } from "react-router-dom";
import { useNoAuth } from "../../hooks/useNoAuth";

/**
 * Component that redirects to login but doesn't trigger authentication checks
 *
 * This component is used for the business slug index route to redirect users
 * to the login page without causing authentication loops or unnecessary auth checks.
 */
const LoginRedirect: React.FC = () => {
  // Register this component as not requiring auth to prevent auth checks
  useNoAuth("LoginRedirect");

  return <Navigate to="login" replace />;
};

export default LoginRedirect;
